<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9" class="d-flex justify-start align-center"><h2>Payment</h2></v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <h5>Filter</h5>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field label="Cari" outlined dense v-model="search" :hide-details="true" />
            </v-col>
            <v-col cols="4">
              <v-select
                :hide-details="true"
                :items="statuses"
                outlined
                dense
                item-text="name"
                item-value="value"
                v-model="selectedStatus"
                label="Status"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="getData" depressed>Filter</v-btn>
          <v-btn
            color="primary"
            small
            depressed
            outlined
            class="ml-3"
            @click="
              search = ''
              selectedStatus = 99
              getData()
            "
            >Reset</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="exportData" depressed>Export data</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="data"
        :options.sync="options"
        :server-items-length="total"
        :loading="loadingTable"
        class="elevation-1"
        :items-per-page="limit"
        :footer-props="{
          'items-per-page-options': [5, 10, 50, 100],
        }"
      >
        <template v-slot:[`item.option`]="{ item }">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="warning"
                x-small
                class="mr-3"
                @click="
                  formNavigationDrawer = true
                  formData = {
                    body: item.body,
                    status: item.status,
                    type: item.type,
                    image_filename: getFileName(item.image),
                    image: '',
                  }
                "
                >Ubah</v-btn
              >
              <v-btn
                color="error"
                x-small
                @click="
                  deleteDialog = true
                  selectedDelete = item
                "
                >Hapus</v-btn
              >
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.trade_amount`]="{ item }">
          Rp {{ new Intl.NumberFormat('id-ID').format(item.trade_amount) }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ new Date(item.created_at).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="item.status == 1 ? 'success' : (new Date(item.expired_at) < new Date() ? 'error' : 'warning')"
            dark
            small
          >
            {{
              item.status == 1
                ? 'Paid'
                : new Date(item.expired_at) < new Date()
                ? 'Expired'
                : 'Pending'
            }}
          </v-chip>
        </template>
      </v-data-table>
    </v-col>

    <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.success ? 'success' : 'error'" right bottom>
      {{ alert.message }}
    </v-snackbar>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical, mdiRefresh, mdiFileOutline } from '@mdi/js'
import axios from 'axios'
import Form from './components/Form.vue'
export default {
  components: { Form },
  setup() {
    return {
      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiRefresh,
        mdiFileOutline,
      },
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'))
    },
  },
  data() {
    return {
      alert: {
        status: false,
        success: false,
        message: '',
      },
      timeout: 1200,
      loadingTable: false,
      total: 0,
      data: [],
      limit: 10,
      search: '',
      statuses: [
        { name: 'Semua', value: 99 },
        { name: 'Pending', value: 0 },
        { name: 'Paid', value: 1 },
        // { name: 'Failed', value: 'FAILED' },
        { name: 'Expired', value: 2 },
      ],
      selectedStatus: 99,
      headers: [
        { text: 'Invoice', value: 'transaction_id', sortable: false },
        { text: 'Body', value: 'body', sortable: false },
        //{ text: 'Payment SN', value: 'payment_sn', sortable: false },
        { text: 'Order SN', value: 'order_sn', sortable: false },
        { text: 'Amount', value: 'trade_amount', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Date', value: 'created_at', sortable: false },
        // { text: 'Phone', value: 'phone', sortable: false },
      ],
      options: {},
      formData: {
        invoice: '',
        invoice_number: '',
        payment_method: '',
        status: '',
        order_status: '',
        created_at: '',
        amount: 0,
        customer_id: '',
        full_name: '',
      },
      selectedDelete: null,
      deleteDialog: false,
      formNavigationDrawer: false,
      loadingDeleteButton: false,
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      this.loadingTable = true
      this.data = []
      const token = localStorage.getItem('token')
      const { page, itemsPerPage } = this.options
      const params = {
        page,
        limit: itemsPerPage,
        q: this.search,
        status: this.selectedStatus ?? 99
      }
      const paramsString = new URLSearchParams(params).toString()
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}payment/get_all?${paramsString}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loadingTable = false
          if (res.status == 200) {
            const data = res.data
            if (data.success) {
              this.total = data.data.count
              this.data = data.data.rows
            } else {
              this.alert = {
                status: true,
                success: false,
                message: data.message,
              }
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          this.loadingTable = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    exportData() {
      const token = localStorage.getItem("token");

      const params = {
        q: this.search,
        status: this.selectedStatus ?? 99
      };

      const paramsString = new URLSearchParams(params).toString();

      axios.get(
        `${process.env.VUE_APP_API_ENDPOINT}payment/export?${paramsString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          responseType: "blob"
        }
      )
      .then((res) => {

        const blob = new Blob(
          [res.data],
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;
        link.download = `payment-${Date.now()}.xlsx`;

        document.body.appendChild(link);

        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

      })
      .catch((err) => {
        console.error(err);

        this.alert = {
          status: true,
          success: false,
          message: "Failed to export data."
        };
      });
    },

    getDetail() {
      this.loading = true

      const token = localStorage.getItem('token')
      const invoice = this.$route.params.invoice

      axios
        .get(
          `${process.env.VUE_APP_API_ENDPOINT}payment/${invoice}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(res => {
          this.loading = false

          if (res.data.success) {
            this.payment = res.data.data
          }
        })
        .catch(err => {
          this.loading = false

          if (err.response?.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    }
  },
}
</script>

<style>
</style>


